export const NAVIGATION_FIXED = 'navigation--fixed';
export const NAVIGATION_PADDING = 'js-navigation-padding';
export const NAVIGATION_PURCHASE_BAR = 'js-navigation-purchase-bar';
export const NAVIGATION_MOBILE_DROPDOWN = 'js-navigation-mobile-dropdown';
export const NAVIGATION_DESKTOP_DROPDOWN = 'js-navigation-desktop-dropdown';
